var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.288,
    height: 45.774,
    viewBox: "0 0 212.288 45.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1074.941 -137.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-330.51,141.966c4.331.083,8.622-.008,12.885.295,4.161.3,6.405,2.994,6.505,7.215.05,2.091-.128,4.167-1.629,5.763a23.1,23.1,0,0,1-3.057,2.338l2.245,4.235,3.446-3.8h6.806l-8.013,7.849,5.884,11.33h-4.908l-4.059-7.814-3.38,3.405h-6.534l7.466-7.8-3.474-6.955h-5.731v9.021h-4.454Zm4.461,12.533c2.468-.093,4.906-.074,7.318-.312a3.309,3.309,0,0,0,3-3.185,9.087,9.087,0,0,0,.024-1.706,3.359,3.359,0,0,0-3.169-3.442c-2.365-.222-4.753-.191-7.172-.27Z",
    transform: "translate(-564.484 -3.345)",
    fill: "#392f87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-527,187.5h-4.678l-5.34-18.608h4.683l3.386,13.713,3.676-13.692h3.856l3.488,13.82,3.607-13.84h4.428l-5.4,18.571h-4.852L-523.56,175.4-527,187.5",
    transform: "translate(-407.891 -23.762)",
    fill: "#3a2f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-1055.252,141.381c-.086,1.409-.165,2.7-.241,3.935-1.782-.218-3.521-.468-5.269-.635a11.3,11.3,0,0,0-4.91.538,6.286,6.286,0,0,0-4.252,4.676,14.983,14.983,0,0,0-.051,7.019,6.538,6.538,0,0,0,6.467,5.475,31.068,31.068,0,0,0,3.186-.042,9.865,9.865,0,0,0,1.284-.224V153.45h4.364V165.4c-1.361.263-2.74.595-4.138.786a20.9,20.9,0,0,1-7.512-.114,9.946,9.946,0,0,1-7.969-7.632,18.026,18.026,0,0,1,.277-10.508,10.1,10.1,0,0,1,8.4-7.073,28.81,28.81,0,0,1,10.36.523",
    transform: "translate(0 -2.295)",
    fill: "#f05917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-718.395,167.342h3.3l.449,2.225c.374-.349.666-.635.972-.9,3.087-2.72,9.893-2.931,11.87,3.3a14.225,14.225,0,0,1,.052,8.589c-1.1,3.632-4.13,5.76-8.146,5.767-1.39,0-2.781-.192-4.222-.3v7.129h-4.273Zm4.273,14.9a8.772,8.772,0,0,0,4.6.4,4.232,4.232,0,0,0,3.534-2.911,9.66,9.66,0,0,0-.068-6.776,3.491,3.491,0,0,0-3.285-2.452,5.619,5.619,0,0,0-4.622,2.316.838.838,0,0,0-.155.5c-.009,2.957-.007,5.914-.007,8.918",
    transform: "translate(-270.36 -22.216)",
    fill: "#3a2f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-401.8,181.879v3.5a18.2,18.2,0,0,1-10.962.6A7.331,7.331,0,0,1-418,180.06a14.389,14.389,0,0,1,.186-7.015,7.763,7.763,0,0,1,7.712-5.955,14.917,14.917,0,0,1,3.626.341c3,.719,4.9,3.272,5.108,6.66a19.7,19.7,0,0,1-.028,2.257c-.027.486-.134.967-.217,1.522h-12.143a4.306,4.306,0,0,0,3.739,4.921,17.573,17.573,0,0,0,7.382-.678c.271-.068.537-.15.844-.235m-3.9-6.9c.218-2.779-1.123-4.474-3.527-4.529a4.185,4.185,0,0,0-4.581,4.529Z",
    transform: "translate(-497.876 -22.395)",
    fill: "#3a2f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-972.157,177.878c-.126,3.074,1.808,4.97,5.043,5.075a20.8,20.8,0,0,0,6.222-.859l.8-.218v3.439a13.65,13.65,0,0,1-4.974,1.116,25.24,25.24,0,0,1-5.031-.22c-3.507-.611-5.543-2.875-6.257-6.3a14.3,14.3,0,0,1,.228-6.86,7.723,7.723,0,0,1,7.71-5.948,15.04,15.04,0,0,1,3.7.37,6.608,6.608,0,0,1,4.967,6.178c.107,1.379-.016,2.776-.036,4.232Zm8.2-2.885c0-3.057-1.234-4.518-3.752-4.535-2.666-.018-4.4,1.74-4.436,4.535Z",
    transform: "translate(-74.52 -22.401)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-788.82,177.894h-12.2c-.095,3.038,1.809,4.908,5.042,5.019a20.682,20.682,0,0,0,6.218-.852c.248-.068.5-.135.8-.216v3.5c-3.762,1.2-7.545,1.74-11.37.46a7.058,7.058,0,0,1-4.667-5.14,13.882,13.882,0,0,1,.129-7.98,7.694,7.694,0,0,1,7.548-5.634,15.207,15.207,0,0,1,3.022.193,6.725,6.725,0,0,1,5.66,5.914,13.37,13.37,0,0,1-.175,4.737m-12.162-2.948h8.092c.3-2.558-1.012-4.375-3.235-4.515-2.929-.185-4.8,1.526-4.857,4.515",
    transform: "translate(-204.29 -22.362)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-885.369,173.248v12.758h-4.241V167.458h3.292l.43,2.342c.307-.292.549-.552.82-.777a8.339,8.339,0,0,1,8.4-1.53A5.483,5.483,0,0,1-873,172.211a12.727,12.727,0,0,1,.148,2.015c.014,3.635.007,7.271.007,10.906,0,.281,0,.562,0,.89h-4.342V185.2q0-5.219,0-10.439c0-3.409-2.093-4.874-5.306-3.712a6.426,6.426,0,0,0-2.878,2.2",
    transform: "translate(-140.532 -22.312)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-626.024,167l.78,1.92c-3.015,1.314-8.332.839-12.022-2.665a12.136,12.136,0,0,1-2.575-13.834A11.9,11.9,0,0,1-628.6,145.51l-1.505,6.436a5.8,5.8,0,0,0-4.057,3.461,5.372,5.372,0,0,0,1.61,6.392,6.62,6.62,0,0,1,2.2,3.418c-2.7-.083-5.527-2.777-6.275-5.983a7.987,7.987,0,0,1,4.813-9.119l.453-2.005a9.715,9.715,0,0,0-7.339,10.274A9.976,9.976,0,0,0-626.024,167",
    transform: "translate(-329.072 -6.018)",
    fill: "#3b3088"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-571.45,189.771a10.09,10.09,0,0,0,5.025-10.327c-.331.109-.589.188-.842.28s-.481.189-.8.316l-.778-1.91,3.827-1.538a11.909,11.909,0,0,1-5.608,15.192l-.821-2.013",
    transform: "translate(-381.785 -29.601)",
    fill: "#3b3088"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-234.309,139.665a5.128,5.128,0,0,1,5.2,5.093,5.2,5.2,0,0,1-5.184,5.218,5.146,5.146,0,0,1-5.142-5.159,5.093,5.093,0,0,1,5.127-5.152m.066,9.724a4.565,4.565,0,0,0,4.564-4.624,4.644,4.644,0,0,0-4.644-4.582,4.652,4.652,0,0,0-4.568,4.663,4.57,4.57,0,0,0,4.647,4.543",
    transform: "translate(-633.543 -1.6)",
    fill: "#43388d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-586.057,142.151q.017.837.033,1.674l.376.938.93,1.9-.994.71c-.5-1.2-1.088-2.333-1.451-3.528a3.641,3.641,0,0,1,1.346-4.023,11.7,11.7,0,0,1,4.893-2.256c.277-.069.632.174.951.272l.011.341a10.266,10.266,0,0,1-.943.521c-1.016.436-2.042.847-3.064,1.268l-.848.532-.943,1.02-.3.629",
    transform: "translate(-369.741 0)",
    fill: "#3d3289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-585.311,193.405l.75-1.413-.006-.888-1.261-3.333.77-.521a8.923,8.923,0,0,1,1.627,3.766,3.72,3.72,0,0,1-1.155,3.324,10.892,10.892,0,0,1-4.944,2.491,2.6,2.6,0,0,1-.8-.036c-.273-.681.153-.868.563-1.037.547-.225,1.106-.422,1.66-.631l.793-.336,1.467-.9.535-.488",
    transform: "translate(-367.404 -37.683)",
    fill: "#3d3289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-582.054,154.594l.3-.629c2.11.719,4.217,1.442,6.331,2.147a.968.968,0,0,0,.65.005c.61-.285,1.135-.274,1.431.391a.841.841,0,0,1-.467,1.225c-.659.261-1.1-.026-1.314-.68-.015-.046-.062-.082-.145-.189l-6.782-2.27",
    transform: "translate(-373.744 -12.443)",
    fill: "#5d9e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-595.18,198l-.535.488-5.99-3.417c-1.107.2-1.617.015-1.71-.635a.909.909,0,0,1,.753-1.1c.583-.143,1,.249,1.158,1.088L-595.18,198",
    transform: "translate(-357.536 -42.28)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-586.031,188.894q0,.444.006.888l-4.448-3.36c-1.153.219-1.785-.083-1.867-.882a1.132,1.132,0,0,1,1.06-1.2c.745-.036,1.143.464,1.173,1.542l4.076,3.015",
    transform: "translate(-365.94 -35.473)",
    fill: "#5d9e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-581.539,164.431l-.376-.938,4.093,1.886c1.035-.461,1.677-.328,1.949.408a1.1,1.1,0,0,1-.68,1.446c-.693.228-1.219-.177-1.569-1.263l-3.418-1.54",
    transform: "translate(-373.849 -19.668)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-576.922,148.076l.848-.532,4.8,1.062c.528-.26,1.106-.626,1.551.081a.764.764,0,0,1-.268,1.147c-.655.37-1.068-.01-1.377-.582l-5.55-1.176",
    transform: "translate(-377.635 -7.575)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-576.979,178.1a1.366,1.366,0,0,1-1.4,1.343,1.375,1.375,0,0,1-1.3-1.377,1.371,1.371,0,0,1,1.373-1.381,1.364,1.364,0,0,1,1.329,1.414",
    transform: "translate(-375.543 -29.674)",
    fill: "#5a9d35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-596.156,208.7l-.792.336-3.639-1.9c-.639.218-1.234.255-1.452-.525a.744.744,0,0,1,.614-.994c.662-.131,1.029.212,1.077.88l4.191,2.2",
    transform: "translate(-358.561 -51.587)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-554.256,142.718a2.722,2.722,0,0,1-.852.33c-.133.006-.4-.345-.394-.534s.258-.549.391-.544a2.744,2.744,0,0,1,.858.329q0,.209,0,.418",
    transform: "translate(-393.878 -3.349)",
    fill: "#64a13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-597.182,218.391c-.288-.44-.575-.687-.544-.883.036-.223.356-.4.553-.6.193.2.51.38.543.6.028.2-.26.44-.552.877",
    transform: "translate(-361.859 -60.175)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M-216.707,157.237l-.988-2.828a20.3,20.3,0,0,1-.193,2.622l-.337-.056v-3.509h.7l.995,2.863,1.013-2.844.636-.079v3.587c-.361-.122-.361-.122-.45-2.564-.565.845-.484,1.969-1.377,2.808",
    transform: "translate(-649.627 -12.02)",
    fill: "#3e338a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M-230.727,153.76v3.025l-.594.088v-3.1l-1.283-.1c.194-.2.276-.365.39-.39a4,4,0,0,1,2.691.392l-1.2.075",
    transform: "translate(-638.723 -11.881)",
    fill: "#473b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-833.27,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.836,1.836,0,0,1-1.6-.653,3.505,3.505,0,0,1-.47-2.032q0-2.748,2.183-2.748a2,2,0,0,1,1.578.59,2.749,2.749,0,0,1,.522,1.854l-.042.6h-3.448a2.142,2.142,0,0,0,.313,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.268,2.268,0,0,0-.308-1.358,1.192,1.192,0,0,0-1-.4,1.285,1.285,0,0,0-1.045.418,2.108,2.108,0,0,0-.36,1.337Z",
    transform: "translate(-180.385 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-813.1,300.608h-.783v-5.224h.773v.366a3.338,3.338,0,0,1,1.619-.47,1.544,1.544,0,0,1,1.405.564,3.984,3.984,0,0,1,.36,2.006v2.758h-.773v-2.737a3.532,3.532,0,0,0-.214-1.489.94.94,0,0,0-.914-.4,2.724,2.724,0,0,0-.705.1,3.525,3.525,0,0,0-.57.193l-.2.094Z",
    transform: "translate(-197.952 -119.599)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-787.457,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.836,1.836,0,0,1-1.6-.653,3.505,3.505,0,0,1-.47-2.032q0-2.748,2.183-2.748a2,2,0,0,1,1.577.59,2.749,2.749,0,0,1,.522,1.854l-.042.6h-3.448a2.143,2.143,0,0,0,.313,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.268,2.268,0,0,0-.308-1.358,1.192,1.192,0,0,0-1-.4,1.285,1.285,0,0,0-1.045.418,2.108,2.108,0,0,0-.36,1.337Z",
    transform: "translate(-215.124 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M-766.971,291.378h-1.661v2.5a3.374,3.374,0,0,0,.131,1.181q.131.282.622.282l.93-.063.052.648a7.146,7.146,0,0,1-1.066.115,1.365,1.365,0,0,1-1.128-.4,2.59,2.59,0,0,1-.313-1.515v-2.748h-.742V290.7h.742v-1.6h.773v1.6h1.661Z",
    transform: "translate(-231.118 -114.913)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M-752.642,287.069h.784v.909h-.784Zm0,2.089h.784v5.224h-.784Z",
    transform: "translate(-244.391 -113.373)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M-741.523,295.281a9.021,9.021,0,0,1,1.17.125l.251.031-.031.637a12.275,12.275,0,0,0-1.233-.094,1.434,1.434,0,0,0-1.207.423,2.75,2.75,0,0,0-.319,1.567,3.064,3.064,0,0,0,.3,1.593,1.4,1.4,0,0,0,1.238.449l1.233-.094.031.648a10.751,10.751,0,0,1-1.452.146,1.979,1.979,0,0,1-1.687-.627,3.649,3.649,0,0,1-.465-2.116,3.315,3.315,0,0,1,.5-2.09,2.066,2.066,0,0,1,1.672-.6",
    transform: "translate(-251.175 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M-712.314,287.649q-1.567,0-1.567,1.181a1.018,1.018,0,0,0,.36.9,4.813,4.813,0,0,0,1.463.491,3.713,3.713,0,0,1,1.562.637,1.611,1.611,0,0,1,.46,1.29q0,2.226-2.309,2.225a12.931,12.931,0,0,1-1.912-.178l-.376-.052.084-.669a17.861,17.861,0,0,0,2.162.188q1.546,0,1.546-1.452a.987.987,0,0,0-.339-.841,3.306,3.306,0,0,0-1.27-.433,4.276,4.276,0,0,1-1.734-.674,1.68,1.68,0,0,1-.512-1.384q0-1.943,2.33-1.943a12.847,12.847,0,0,1,1.828.157l.355.052-.073.679a19.619,19.619,0,0,0-2.058-.178",
    transform: "translate(-273.165 -113.274)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M-688.579,295.281a9.022,9.022,0,0,1,1.17.125l.251.031-.031.637a12.272,12.272,0,0,0-1.233-.094,1.434,1.434,0,0,0-1.207.423,2.75,2.75,0,0,0-.319,1.567,3.064,3.064,0,0,0,.3,1.593,1.4,1.4,0,0,0,1.238.449l1.233-.094.031.648a10.753,10.753,0,0,1-1.452.146,1.979,1.979,0,0,1-1.688-.627,3.649,3.649,0,0,1-.465-2.116,3.316,3.316,0,0,1,.5-2.09,2.067,2.067,0,0,1,1.672-.6",
    transform: "translate(-291.321 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-670.611,287.069h.783v.909h-.783Zm0,2.089h.783v5.224h-.783Z",
    transform: "translate(-306.593 -113.373)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-657.926,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.836,1.836,0,0,1-1.6-.653,3.508,3.508,0,0,1-.47-2.032q0-2.748,2.183-2.748a2,2,0,0,1,1.578.59,2.749,2.749,0,0,1,.523,1.854l-.042.6h-3.448a2.142,2.142,0,0,0,.313,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.268,2.268,0,0,0-.308-1.358,1.191,1.191,0,0,0-1-.4,1.285,1.285,0,0,0-1.045.418,2.109,2.109,0,0,0-.36,1.337Z",
    transform: "translate(-313.344 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-637.758,300.608h-.784v-5.224h.773v.366a3.34,3.34,0,0,1,1.62-.47,1.545,1.545,0,0,1,1.405.564,3.985,3.985,0,0,1,.36,2.006v2.758h-.773v-2.737a3.533,3.533,0,0,0-.214-1.489.94.94,0,0,0-.914-.4,2.726,2.726,0,0,0-.705.1,3.526,3.526,0,0,0-.569.193l-.2.094Z",
    transform: "translate(-330.91 -119.599)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M-613.679,295.281a9.021,9.021,0,0,1,1.17.125l.251.031-.031.637a12.269,12.269,0,0,0-1.233-.094,1.434,1.434,0,0,0-1.207.423,2.753,2.753,0,0,0-.319,1.567,3.06,3.06,0,0,0,.3,1.593,1.4,1.4,0,0,0,1.238.449l1.233-.094.031.648a10.752,10.752,0,0,1-1.452.146,1.979,1.979,0,0,1-1.688-.627,3.649,3.649,0,0,1-.465-2.116,3.316,3.316,0,0,1,.5-2.09,2.067,2.067,0,0,1,1.672-.6",
    transform: "translate(-348.116 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-593.139,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.836,1.836,0,0,1-1.6-.653,3.507,3.507,0,0,1-.47-2.032q0-2.748,2.183-2.748a2,2,0,0,1,1.578.59,2.749,2.749,0,0,1,.523,1.854l-.042.6h-3.448a2.142,2.142,0,0,0,.313,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.268,2.268,0,0,0-.308-1.358,1.191,1.191,0,0,0-1-.4,1.285,1.285,0,0,0-1.045.418,2.108,2.108,0,0,0-.36,1.337Z",
    transform: "translate(-362.471 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-563.858,302.929v-7.543h.773v.376a3.012,3.012,0,0,1,1.567-.481,1.646,1.646,0,0,1,1.442.632,3.694,3.694,0,0,1,.449,2.084,3.258,3.258,0,0,1-.528,2.084,2.161,2.161,0,0,1-1.75.632,5.568,5.568,0,0,1-1.17-.115v2.33Zm2.225-6.948a2.429,2.429,0,0,0-.674.1,3.509,3.509,0,0,0-.569.209l-.2.1v3.521a7.973,7.973,0,0,0,1.128.115,1.353,1.353,0,0,0,1.186-.481,2.782,2.782,0,0,0,.339-1.567,2.9,2.9,0,0,0-.308-1.546,1.02,1.02,0,0,0-.9-.46",
    transform: "translate(-387.542 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M-541.644,297.986a3.314,3.314,0,0,1,.512-2.069,2.1,2.1,0,0,1,1.729-.637,2.081,2.081,0,0,1,1.724.637,3.343,3.343,0,0,1,.507,2.069,3.533,3.533,0,0,1-.481,2.079,2.059,2.059,0,0,1-1.755.648,2.058,2.058,0,0,1-1.755-.648,3.53,3.53,0,0,1-.481-2.079m.8-.016a3.325,3.325,0,0,0,.277,1.6,1.25,1.25,0,0,0,1.16.46,1.244,1.244,0,0,0,1.154-.454,3.364,3.364,0,0,0,.272-1.6,2.941,2.941,0,0,0-.3-1.583,1.28,1.28,0,0,0-1.123-.434,1.3,1.3,0,0,0-1.128.434,2.888,2.888,0,0,0-.308,1.577",
    transform: "translate(-404.386 -119.599)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M-519.471,295.713h.783l1.055,4.545h.167l1.243-4.44h.815l1.243,4.44h.178l1.045-4.545h.783l-1.243,5.224h-1.306l-1.108-4.085-1.108,4.085h-1.306Z",
    transform: "translate(-421.199 -119.928)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M-481.761,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.836,1.836,0,0,1-1.6-.653,3.505,3.505,0,0,1-.47-2.032q0-2.748,2.184-2.748a2,2,0,0,1,1.578.59,2.75,2.75,0,0,1,.522,1.854l-.042.6h-3.448a2.142,2.142,0,0,0,.314,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.27,2.27,0,0,0-.308-1.358,1.192,1.192,0,0,0-1-.4,1.286,1.286,0,0,0-1.045.418,2.108,2.108,0,0,0-.36,1.337Z",
    transform: "translate(-446.926 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M-462.375,300.576v-5.224h.773v.71a5.092,5.092,0,0,1,1.912-.826v.794a5.628,5.628,0,0,0-.914.261,6.089,6.089,0,0,0-.726.313l-.261.136v3.834Z",
    transform: "translate(-464.494 -119.567)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M-444.634,299.961l.3-.031.021.616a15,15,0,0,1-2.037.167,1.835,1.835,0,0,1-1.6-.653,3.505,3.505,0,0,1-.47-2.032q0-2.748,2.183-2.748a2,2,0,0,1,1.578.59,2.75,2.75,0,0,1,.522,1.854l-.042.6h-3.448a2.142,2.142,0,0,0,.314,1.285,1.281,1.281,0,0,0,1.092.418q.778,0,1.583-.063m-.282-2.267a2.27,2.27,0,0,0-.308-1.358,1.192,1.192,0,0,0-1-.4,1.285,1.285,0,0,0-1.045.418,2.108,2.108,0,0,0-.36,1.337Z",
    transform: "translate(-475.078 -119.6)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M-421.959,286.291v7.5h-.773v-.355a3.184,3.184,0,0,1-1.588.46,2.316,2.316,0,0,1-.731-.1,1.5,1.5,0,0,1-.585-.376,2.947,2.947,0,0,1-.564-2.084,3.7,3.7,0,0,1,.507-2.194,1.963,1.963,0,0,1,1.677-.674,6.572,6.572,0,0,1,1.285.136v-2.309Zm-2.716,6.833a1.357,1.357,0,0,0,.486.073,2.613,2.613,0,0,0,.669-.1,4.011,4.011,0,0,0,.58-.193l.209-.094v-3.542a6.791,6.791,0,0,0-1.243-.125,1.2,1.2,0,0,0-1.107.507,3.07,3.07,0,0,0-.314,1.572,2.586,2.586,0,0,0,.366,1.63.9.9,0,0,0,.355.272",
    transform: "translate(-491.923 -112.783)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M-389.791,288.464a1.685,1.685,0,0,1,1.478.6,3.832,3.832,0,0,1,.423,2.105,3.269,3.269,0,0,1-.528,2.116,2.481,2.481,0,0,1-1.938.611q-.439,0-1.452-.084l-.293-.031v-7.491h.773v2.539a3.665,3.665,0,0,1,1.536-.366m-.575,4.733a1.578,1.578,0,0,0,1.353-.465,2.816,2.816,0,0,0,.329-1.572,3.291,3.291,0,0,0-.261-1.552.988.988,0,0,0-.93-.444,3.657,3.657,0,0,0-1.243.23l-.209.073v3.678q.679.052.961.052",
    transform: "translate(-517.781 -112.783)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-371.4,295.713h.784l1.306,4.545h.345l1.316-4.545h.784l-2.173,7.543h-.783l.679-2.319h-.773Z",
    transform: "translate(-533.48 -119.928)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M-336.838,294.644h-.8v-7.23h.8v3.364l1.191-.042,1.849-3.322h.92l-2.069,3.636,2.183,3.594h-.951l-1.922-3.2-1.2.042Z",
    transform: "translate(-559.075 -113.635)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-278.056,294.644v-3.27h-3.678v3.27h-.8v-7.23h.8v3.239h3.678v-3.239h.794v7.23Z",
    transform: "translate(-600.86 -113.635)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M-311.359,290.682a1.745,1.745,0,0,1-.983-2.042,1.8,1.8,0,0,1,1.773-1.443,10.9,10.9,0,0,1,2.222.11c.146.018.249.374.431.672-.892-.054-1.584-.144-2.273-.125-.9.025-1.363.485-1.382,1.241-.02.814.4,1.267,1.37,1.31,1.165.052,2.334.012,3.568.012,0,.215.038.505-.006.518-.683.2-.4.73-.405,1.145a2.286,2.286,0,0,1-2.322,2.474,7.876,7.876,0,0,1-.9,0,2.127,2.127,0,0,1-2.187-1.355c-.3-.967.009-1.722,1.09-2.519m1.5,3.232a7.358,7.358,0,0,0,1.154-.25,1.791,1.791,0,0,0,.9-2.085c-.159-.838-.842-.5-1.318-.539a5.525,5.525,0,0,0-1.483.1,1.328,1.328,0,0,0-1.1,1.662c.126.693.738,1.045,1.84,1.111",
    transform: "translate(-578.096 -113.454)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-859.405,291.4v2.162a7.913,7.913,0,0,1-1.494.147,1.722,1.722,0,0,1-1.609-.695,4.709,4.709,0,0,1-.418-2.309,4.709,4.709,0,0,1,.418-2.309,1.734,1.734,0,0,1,1.619-.695,13.715,13.715,0,0,1,2.246.219l.031-.669-.355-.063a10.283,10.283,0,0,0-2.016-.209,2.415,2.415,0,0,0-2.168.914,5.132,5.132,0,0,0-.611,2.811,5.1,5.1,0,0,0,.611,2.805,2.446,2.446,0,0,0,2.189.909,12.7,12.7,0,0,0,2.351-.251V291.4Z",
    transform: "translate(-160.132 -113.307)",
    fill: "#1a1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.91f5d352c04a0889974e400be32143f9.svg";
export { ForwardRef as ReactComponent };